import React from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { MdClose } from 'react-icons/md';
import './googleMap.css';

export class MapContainer extends React.Component {
	state = {
		mapCenter: {
			lat: 34.052235,
			lng: -118.243683
		},

		address: ''
	};

	handleChange = (address) => {
		this.setState({ address });
	};

	handleSelect = (address) => {
		geocodeByAddress(address)
			.then((results) => getLatLng(results[0]))
			.then((latLng) => {
				console.log('Success', latLng);
				this.setState({ address });
				this.setState({ mapCenter: latLng });
			})
			.catch((error) => console.error('Error', error));
	};

	clearInputField = () => {
		this.setState({ address: '' });
		return this.state.address;
	};

	render() {
		return (
			<React.Fragment>
				<div className="google-maps-container">
					<PlacesAutocomplete
						value={this.state.address}
						onChange={this.handleChange}
						onSelect={this.handleSelect}>
						{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
							<div className="search-input-container">
								<div className="input-box-container">
									<input
										style={{ width: 'inhert' }}
										{...getInputProps({
											placeholder: 'Find a gym near you...',
											className: 'location-search-input'
										})}
									/>
									<MdClose className="clear-input-icon" onClick={this.clearInputField} />
								</div>
								<div className="autocomplete-dropdown-container">
									{loading && <div>Loading...</div>}
									{suggestions.map((suggestion) => {
										const className = suggestion.active
											? 'suggestion-item--active'
											: 'suggestion-item';
										// inline style for demonstration purpose
										const style = suggestion.active
											? { backgroundColor: '#fafafa', cursor: 'pointer' }
											: { backgroundColor: '#ffffff', cursor: 'pointer' };
										return (
											<div
												key={suggestion.placeId}
												{...getSuggestionItemProps(suggestion, {
													className,
													style
												})}>
												<span>{suggestion.description}</span>
											</div>
										);
									})}
								</div>
							</div>
						)}
					</PlacesAutocomplete>

					<Map
						className="google-maps"
						// style={{ height: '50%', width: '500px' }}
						google={this.props.google}
						initialCenter={{
							lat: this.state.mapCenter.lat,
							lng: this.state.mapCenter.lng
						}}
						center={{
							lat: this.state.mapCenter.lat,
							lng: this.state.mapCenter.lng
						}}>
						<Marker
							position={{
								lat: this.state.mapCenter.lat,
								lng: this.state.mapCenter.lng
							}}
						/>
					</Map>
				</div>
			</React.Fragment>
		);
	}
}

export default GoogleApiWrapper({
	apiKey: 'AIzaSyArbRxu-wMKjjboGdgu9ZkIgCTxmXoXzn8'
})(MapContainer);
